module.exports = __webpack_public_path__ + "static/img/tslp.f6d117d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tslp.png
// module id = y79C
// module chunks = 1